import { IconButton } from "@mui/material";
import React from "react";
import { FiPlus } from "react-icons/fi";

const GradientButtonPlus: React.FC<any> = ({ onClick }) => {
  const estilo = {
    background: "linear-gradient(to right, #4a76fb, #06d986)",
    color: "white",
  };
  return (
    <IconButton onClick={onClick} sx={estilo} style={{ borderRadius: 8 }}>
      <FiPlus color="#fff" size={22} />
    </IconButton>
  );
};

export default GradientButtonPlus;
